import {Set, Record, Map} from "immutable"

interface Properties {
    id: number
    regionId: number
    title: string
    abbreviation: string
    type: string
//    specialitiesOpk: Set<number>
}

export class UniversityBranch extends Record({
    id: undefined,
    regionId: undefined,
    title: undefined,
    abbreviation: undefined,
    type: undefined,
//    specialitiesOpk: undefined,
}) implements Properties {
    id: number
    regionId: number
    title: string
    abbreviation: string
    type: string
//    specialitiesOpk: Set<number>

    constructor(values: Properties) {
        super(values)
    }
}

export type JsonData =  {
    id: number
    regionId: number
    title: string
    abbreviation: string
    type: string
//    specialitiesOpk: number[]
}

export const fromJs = ({
    id,
    regionId,
    title,
    abbreviation,
    type,
//    specialitiesOpk,
}: JsonData): UniversityBranch => new UniversityBranch({
    id,
    regionId,
    title,
    abbreviation,
    type,
//    specialitiesOpk: Set(specialitiesOpk),
})

export type UniversityBranches = Map<number, UniversityBranch>